var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callback"},[_c('h1',[_vm._v("打假办收到举报信息后")]),_vm._v(" "),_c('p',[_vm._v("1、进一步确认信息")]),_vm._v(" "),_c('p',[_vm._v("2、采取打假行动")]),_vm._v(" "),_c('p',[_vm._v("3、奖励举报人")]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('button',{on:{"click":_vm.back}},[_vm._v("返回举报界面")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88cb0f84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/example01/callback.vue
// module id = null
// module chunks = 